import React from "react";
import { FormattedMessage } from "react-intl";

import { LoginForm as LoginForm2g } from "2g-auth";
import { Logos } from "2g-icons";
import { LangSwitchRow, LangSwitchItem } from "2g-intl";
import { LANGUAGE } from "2g-i18n";

function LoginForm() {
  return (
    <LoginForm2g
      logo={<Logos.VUZLogo />}
      appName={
        <FormattedMessage
          id="b2b.navigation.title"
          defaultMessage="B2B Portál"
        />
      }
      langSwitch={
        <LangSwitchRow>
          <LangSwitchItem lang={LANGUAGE.CZECH}>CS</LangSwitchItem>
          <LangSwitchItem lang={LANGUAGE.ENGLISH}>EN</LangSwitchItem>
        </LangSwitchRow>
      }
    />
  );
}

export default React.memo(LoginForm);
